/** Catálogo português (Brasil/Portugal) — claves planas; misma estructura que en.ts */
const pt = {
  unique_death_history: "Registro de mortes",
  reg_events: "Eventos",
  reg_details: "Descrição e recompensas",
  reg_details_pending: "Os detalhes serão anunciados em breve.",
  reg_open: "Aberto",
  reg_closed: "Fechado",
  reg_joined: "Inscrito",
  reg_equalized: "Equalizado",
  reg_standard: "Normal",
  reg_cancel_registration: "Cancelar inscrição",
  reg_joined_hint: "Você está inscrito neste evento.",
  reg_open_hint: "Inscrições abertas. Inscreva-se para participar.",
  reg_closed_hint: "As inscrições estão fechadas.",
  reg_translating: "Traduzindo…",
  reg_translation_error: "Tradução indisponível. Exibindo o texto original.",
  reg_retry: "Tentar novamente",

  battle_pass: 'Passe de Batalha',
  menu_main: 'Menu principal',
  menu_tools: 'Ferramentas',
  menu_open: 'Abrir menu',
  menu_close: 'Fechar menu',
  menu_home: 'Voltar ao início',
  guide: 'Guia',
  daily_login: 'Login Diário',
  spin_title: 'Roleta',
  special_offer: 'Oferta Especial',
  auction_system: 'Casa de Leilão',
  title_manager: 'Personalização',
  ranking: 'Ranking',
  unique: 'Únicos',
  job_system: 'Sistema de Trabalho',
  vip_system: 'VIP',
  donation: 'Doação',
  surveys: 'Pesquisas',
  settings: 'Configurações',
  messages: 'Mensagens',
  unique_status_title: 'Status Atual',
  unique_logs_title: 'Histórico',
  unique_table_name: 'Unique',
  unique_table_character: 'Personagem',
  unique_table_status: 'Status',
  unique_table_event: 'Evento',
  unique_table_map: 'Mapa',
  unique_table_time: 'Hora',
  unique_status_alive: 'Vivo',
  unique_status_dead: 'Morto',
  unique_event_spawn: 'Apareceu',
  unique_event_death: 'Eliminado',
  unique_refresh: 'Atualizar',
  unique_sort_alive_first: 'Ordenar: vivos primeiro',
  unique_sort_dead_first: 'Ordenar: mortos primeiro',
  unique_deaths_tooltip_title: 'Últimas 5 eliminações',
  unique_deaths_empty: 'Nenhuma eliminação registrada',
  unique_load_error: 'Não foi possível carregar o histórico de Uniques.',
  unique_no_data: 'Nenhum dado encontrado.',
  unique_logs_empty: 'Nenhum evento no histórico ainda.',
  schedule: 'Horário',
  sched_no_events: 'Nenhum evento agendado.',
  sched_running: 'EM EXECUÇÃO',
  sched_load_error: 'Não foi possível carregar o horário. Tente novamente mais tarde.',
  reg_register: 'Registrar',
  reg_remove_register: 'Remover registro',
  reg_processing: 'Processando...',
  reg_registered_success: 'Você se registrou no evento com sucesso',
  reg_unregistered_success: 'Você cancelou o registro do evento com sucesso',
  reg_no_events: 'Nenhum evento disponível.',
  reg_load_error: 'Não foi possível carregar os eventos. Tente novamente mais tarde.',
  reg_error_invalid_event: 'Evento inválido',
  reg_error_not_logged_in: 'Você deve estar logado para registrar eventos',
  reg_error_not_available: 'O evento não está disponível para registro',
  reg_error_already_registered: 'Erro ao registrar no evento. Você pode já estar registrado.',
  reg_error_unregister: 'Erro ao cancelar registro do evento',
  reg_error_processing: 'Erro ao processar solicitação',
  reg_error_connection: 'Erro de conexão. Por favor, tente novamente.',
  reg_modal_title: 'Equalized System',
  reg_weapons: 'Armas (Selecione 1)',
  reg_buffs: 'Buffs (Selecione 1)',
  reg_essence: 'Essence (Sempre ativo)',
  reg_force: 'Force (Sempre ativo)',
  reg_btn_register: 'Registrar',
  reg_btn_cancel: 'Cancelar',
  register: 'Registrar',
  r_ia: 'R-AI',
  chat_welcome_message: 'Olá! 👋 Eu sou o <strong>R-AI</strong>, seu assistente de IA para Silkroad Origins.',
  chat_welcome_question: 'Como posso te ajudar hoje?',
  chat_input_placeholder: 'Digite sua mensagem...',
  chat_send_button: 'Enviar',
  chat_send_title: 'Enviar mensagem',
  chat_char_count: '{current} / {max}',
  chat_load_error: 'Não foi possível carregar o histórico do chat. Tente novamente mais tarde.',
  chat_error_connection: 'Erro de conexão. Por favor, tente novamente.',
  drop_log: 'Registro de Drops',
  log_table_item: 'Item',
  log_table_character: 'Personagem',
  log_table_monster: 'Monstro',
  log_table_map: 'Mapa',
  log_table_date: 'Data',
  log_table_ago: 'Atrás',
  log_search_placeholder: 'Pesquisar...',
  log_time_seconds: 's',
  log_time_minutes: 'min',
  log_time_hours: 'h',
  log_time_days: 'd',
  log_filter_race: 'Raça',
  log_filter_race_chinese: 'Chinese',
  log_filter_race_euro: 'Euro',
  log_filter_type: 'Tipo',
  log_filter_time_all: 'Todos',
  log_filter_time_today: 'Hoje',
  log_filter_time_week: 'Esta Semana',
  log_filter_time_month: 'Este Mês',
  log_filter_apply: 'Aplicar',
  log_filter_reset: 'Resetar',
  log_load_error: 'Não foi possível carregar o registro de drops. Tente novamente mais tarde.',
  log_no_results: 'Nenhum drop corresponde aos seus filtros.',
  log_modal_i_need_it: 'Preciso disso',
  log_modal_sending: 'Enviando...',
  log_modal_sent: 'Enviado',
  log_modal_error: 'Erro',
  log_modal_connection_error: 'Erro de conexão',
  log_modal_message_template: 'Oi, tenho interesse no {item} que você dropou. Quanto você está pedindo?',
  log_chat_button_title: 'Contatar via chat',
  log_chat_self_error: 'Não é possível enviar mensagens para si mesmo',
  languages: 'Idiomas',
  server_time: 'Hora do Servidor',
  loading_data: 'Carregando dados...',
  auth_loading: 'Autenticando...',
  auth_error: 'Não foi possível autenticar. Reabra pelo jogo.',
  bp_duration: 'Duração: {start} - {end} ({remaining} restantes)',
  bp_level: 'Nível',
  bp_buy_pass: 'Comprar Passe',
  bp_premium_active: 'Passe premium ativo',
  bp_premium_reward: 'Recompensa Premium',
  bp_max_level: 'Nível Máximo: {level}',
  bp_no_active: 'Nenhum passe de batalha ativo',
  bp_reward_success: 'Recompensa resgatada com sucesso!',
  bp_claim_error: 'Não foi possível resgatar a recompensa. Tente novamente mais tarde.',
  bp_exp_info_title: 'Experiência do Battle Pass',
  bp_exp_tower_defense_victory: 'Tower Defense: Vitória: 45 pontos | Derrota: 5 pontos',
  bp_exp_hell_prison_victory: 'Prisão Infernal: Vitória: 50 pontos | Derrota: 10 pontos',
  bp_exp_witch_hunt_victory: 'Caça às Bruxas: Vitória: 50 pontos | Derrota: 10 pontos',
  bp_exp_survival: 'Sobrevivência: 1º Lugar: 30 Pontos | 2º Lugar: 15 pontos | 3º Lugar: 5 pontos',
  bp_exp_last_man_standing: 'Último em Pé: Vitória: 95 pontos',
  bp_exp_madness: 'Loucura: 1º Lugar: 30 Pontos | 2º Lugar: 15 pontos | 3º Lugar: 5 pontos',
  bp_exp_garden_job_victory: 'Jardim (Trabalho): Vitória: 50 pontos | Derrota: 10 pontos',
  bp_exp_capture_flag_victory: 'Capturar a Bandeira: Vitória: 50 pontos | Derrota: 10 pontos',
  bp_exp_battle_arena_victory: 'Arena de Batalha: Vitória: 50 pontos | Derrota: 10 pontos',
  bp_exp_league_map_victory: 'Mapa da Liga: Vitória: 55 pontos | Derrota: 10 pontos',
  bp_exp_medusa_victory: 'Medusa: Vitória: 100 pontos | Derrota: 20 pontos',
  bp_exp_roc_victory: 'Roc: Vitória: 100 pontos | Derrota: 20 pontos',
  bp_exp_normal_uniques_victory: 'Uniques Normais: Vitória: 5 pontos | Derrota: 3 pontos',
  bp_exp_arabian_uniques_victory: 'Uniques Árabes: Vitória: 7 pontos | Derrota: 5 pontos',
  bp_exp_legendary_uniques_victory: 'Uniques Lendários: Vitória: 10 pontos | Derrota: 7 pontos',
  bp_exp_job_kills: 'Mortes no Trabalho: 2 pontos por morte',
  bp_exp_job_delivery: 'Entrega de Trabalho: 15 pontos por entrega',
  bp_exp_global_chat: 'Uso do Chat Global: 2 pontos por uso do chat global',
  bp_exp_summary:
    'Ganhe XP do Battle Pass em eventos: Tower Defense, Prisão Infernal, Caça às Bruxas, Sobrevivência, Loucura, Jardim Trabalho, Capturar Bandeira, Arena de Batalha, Mapa da Liga, Medusa, Roc, Uniques, mortes/entregas de trabalho e Chat Global.',
  silk_confirm_cost: 'Custo: {amount} Silks',
  silk_confirm_balance: 'Seu saldo: {amount} Silks',
  silk_confirm_after: 'Saldo após compra: {amount} Silks',
  silk_confirm_not_enough: 'Você não tem Silks suficientes para esta compra.',
  silk_confirm_cancel: 'Cancelar',
  silk_confirm_confirm: 'Confirmar',
  bp_premium_confirm_title: 'Comprar Passe Premium',
  bp_premium_confirm_msg: 'Desbloqueie todas as recompensas premium desta temporada.',
  bp_levelup_confirm_title: 'Subir de Nível',
  bp_levelup_confirm_msg: 'Ganhe instantaneamente um nível de Battle Pass.',
  silk_confirm_price_label: 'Preço',
  silk_confirm_your_silk: 'Seus Silks',
  silk_confirm_checking: 'Verificando...',
  silk_confirm_unavailable: 'Indisponível',
  silk_confirm_retry_later: 'Tentar Mais Tarde',
  silk_confirm_not_enough_short: 'Silks Insuficientes',
  silk_confirm_processing: 'Processando',
  silk_confirm_processing_msg: 'Processando sua compra...',
  silk_confirm_success: 'Sucesso',
  silk_confirm_failed: 'Falhou',
  silk_confirm_wait: 'Aguarde',
  silk_confirm_close: 'Fechar',
  cal_schedule_label: 'Agenda de Check-In: {start} - {end}',
  cal_remaining_label: '({remaining} restantes)',
  cal_checked_in_status: 'Check-in realizado {checked} de {total} dias ({missed} dia(s) perdido(s))',
  cal_day_label: 'Dia {day}',
  cal_checkin_available: 'Você pode fazer check-in agora!',
  cal_next_checkin: 'Próximo check-in em: {hours}h {minutes}min',
  cal_claim_error: 'Não foi possível concluir a ação. Tente novamente mais tarde.',
  cal_no_campaign: 'Nenhuma campanha ativa',
  spin_daily_spins: '{max} Giros Diários ({used}/{max})',
  spin_recent_rewards: 'Últimas 5 Recompensas',
  spin_congratulations: 'Parabéns!',
  spin_probability: 'Probabilidade:',
  spin_daily_reached_tooltip: 'Limite diário atingido. Para usar novamente, compre com Silk.',
  spin_reset_confirm_title: 'Confirmar Reset',
  spin_reset_confirm_message: 'Tem certeza que deseja resetar os giros?',
  spin_reset_confirm_silk: '{amount} silks',
  spin_reset_confirm_cancel: 'Cancelar',
  spin_reset_confirm_confirm: 'Confirmar',
  spin_reset_success: 'Giros resetados com sucesso!',
  spin_reset_error: 'Não foi possível resetar os giros.',
  spin_error_spin: 'Não foi possível girar a roleta.',
  spin_error_winner: 'Item vencedor não encontrado.',
  spin_error_connection: 'Erro de conexão com o servidor.',
  so_title: 'Oferta Especial',
  so_recommended: 'Recomendado',
  so_offer_ends_in: 'A oferta termina em',
  so_buy: 'COMPRAR',
  so_available: 'Disponível',
  so_sold_out: 'Esgotado',
  so_processing: 'Processando...',
  so_purchase_success: 'Compra realizada com sucesso!',
  so_purchase_error: 'Erro na compra',
  so_network_error: 'Erro de rede',
  so_confirm_title: 'Confirmar Compra',
  so_confirm_message: 'Comprar {name}?',
  so_no_offers: 'Nenhuma oferta ativa',
  auc_time_left: 'Tempo restante',
  auc_bid_concluded: 'Lance Concluído',
  auc_winner: 'Vencedor',
  auc_auction_starting_soon: 'Leilão começando em breve',
  auc_enter_bid: 'Digite seu lance',
  auc_bid_now: 'Dar Lance Agora',
  auc_be_first_to_bid: 'Seja o primeiro a dar lance',
  auc_current_bid: 'Lance Atual',
  auc_by: 'por',
  auc_latest_bids: 'Últimos Lances',
  auc_auction_ended: 'O leilão terminou. Parabéns ao vencedor!',
  auc_wait_next_auction: 'Aguarde o próximo leilão começar.',
  auc_item_rewards: 'Recompensas de Itens',
  auc_no_rewards: 'Nenhuma recompensa disponível',
  auc_bid_success: 'Lance enviado com sucesso!',
  auc_bid_error: 'Erro ao enviar lance.',
  auc_invalid_bid: 'Digite um valor de lance válido.',
  tm_tab_name: "Name",
  tm_name_colors: "Cores de nome salvas",
  tm_name_apply: "Aplicar cor",
  tm_name_select: "Selecione uma cor",
  tm_name_empty: "Nenhuma cor salva.",
  tm_name_reuse: "Cada cor custa 999 Silks. Cores compradas podem ser reutilizadas gratuitamente. Aguarde 30 segundos entre alterações.",
  tm_name_buy: "Comprar cor do nome",
  tm_name_purchased: "Cor do nome comprada.",
  tm_name_applied: "Cor do nome aplicada.",
  tm_name_owned: "Já possui",
  tm_name_error: "Não foi possível processar a cor.",
  tm_cooldown: "Aguarde {seconds} segundos antes de outra alteração.",
  tm_tab_title: 'Título',
  tm_tab_icon: 'Ícone',
  tm_tab_tag: 'Tag',
  tm_title_column: 'Título',
  tm_tag_column: 'Tag',
  tm_actions_column: 'Ações',
  tm_enter_title: 'Digite o texto do título...',
  tm_enter_tag: 'Digite o texto da tag...',
  tm_test: 'Testar',
  tm_edit: 'Editar',
  tm_edit_title_modal_title: 'Editar título',
  tm_price_edit: 'Preço de edição',
  tm_error_editing_title: 'Erro ao editar título.',
  tm_title_edited: 'Título atualizado com sucesso.',
  tm_buy: 'Comprar',
  tm_total_pay: 'Total a pagar',
  tm_color_optional: 'Cor personalizada (opcional)',
  tm_edit_separate: 'Editar um título existente (à parte)',
  tm_price_title: 'Preço do Título',
  tm_price_color: 'Preço da Cor',
  tm_price_tag: 'Preço da Tag',
  tm_price_icon_label: '{amount} Silks',
  tm_apply_title: 'Aplicar Título',
  tm_remove_title: 'Remover Título',
  tm_apply_tag: 'Aplicar Tag',
  tm_remove_tag: 'Remover Tag',
  tm_no_titles: 'Nenhum título salvo.',
  tm_no_tags: 'Nenhuma tag salva.',
  tm_no_icons: 'Nenhum ícone encontrado.',
  tm_icon_search: 'Buscar ícones...',
  tm_icon_left: 'Ícone Esquerdo',
  tm_icon_right: 'Ícone Direito',
  tm_buy_title_modal_title: 'Confirmar Compra do Título',
  tm_buy_tag_modal_title: 'Confirmar Compra da Tag',
  tm_buy_icon_modal_title: 'Confirmar Compra do Ícone',
  tm_buy_title_label: 'Título:',
  tm_buy_tag_label: 'Tag:',
  tm_buy_icon_label: 'Ícone:',
  tm_buy_price_label: 'Preço:',
  tm_buy_balance_label: 'Seu saldo:',
  tm_buy_includes: 'Inclui:',
  tm_buy_includes_title_color: 'Título + Cor Personalizada',
  tm_buy_not_enough: '⚠ Você não tem Silks suficientes.',
  tm_buy_needs_more: 'Você precisa de mais {amount} Silks.',
  tm_buy_confirm: 'Confirmar Compra',
  tm_buy_cancel: 'Cancelar',
  tm_error_testing_title: 'Erro ao testar título.',
  tm_error_buying_title: 'Erro ao comprar título.',
  tm_error_buying_tag: 'Erro ao comprar tag.',
  tm_error_buying_icon: 'Erro ao comprar ícone.',
  tm_error_applying_icon: 'Erro ao aplicar ícone.',
  tm_error_getting_balance: 'Erro ao obter saldo de Silk.',
  tm_error_applying_title: 'Erro ao aplicar título.',
  tm_error_applying_tag: 'Erro ao aplicar tag.',
  tm_error_removing_title: 'Erro ao remover título.',
  tm_error_removing_tag: 'Erro ao remover tag.',
  tm_processing: 'Processando...',
  tm_already_have_title: 'Você já possui este título.',
  tm_already_have_tag: 'Você já possui esta tag.',
  tm_already_have_icon: 'Você já possui este ícone.',
  tm_not_enough_silk: 'Silks insuficientes.',
  tm_title_applied: 'Título aplicado com sucesso.',
  tm_title_purchased: 'Título comprado! Aproveite seu novo título.',
  tm_tag_applied: 'Tag aplicada com sucesso.',
  tm_icon_applied: 'Ícone aplicado com sucesso.',
  tm_title_removed: 'Título desativado com sucesso.',
  tm_tag_removed: 'Tag removida com sucesso.',
  tm_icon_purchased: 'Ícone comprado com sucesso.',
  tm_test_applied: 'Pré-visualização do título aplicada (temporária).',
  ranking_search_placeholder: 'Buscar jogador...',
  ranking_filter_race: 'Raça',
  ranking_race_chinese: 'Chinese',
  ranking_race_euro: 'Euro',
  ranking_filter_mastery: 'Maestria',
  ranking_mastery_bicheon: 'Bicheon',
  ranking_mastery_pacheon: 'Pacheon',
  ranking_mastery_heuksal: 'Heuksal',
  ranking_mastery_warrior: 'Guerreiro',
  ranking_mastery_rogue: 'Ladino',
  ranking_mastery_wizard: 'Mago',
  ranking_filter_reset: 'Resetar',
  ranking_filter_refresh: 'Atualizar ranking',
  ranking_col_character: 'Personagem',
  ranking_col_guild: 'Nome do Clã',
  ranking_col_points: 'Pontos',
  ranking_no_results: 'Nenhum jogador corresponde aos seus filtros.',
  ranking_empty: 'Dados de ranking ainda não disponíveis. Tente novamente mais tarde.',
  ranking_error: 'Não foi possível carregar o ranking. Toque ↺ para tentar novamente.',
  ranking_error_auth: 'Não foi possível carregar o ranking. Toque ↺ para tentar novamente.',
  ranking_player_title: 'Ranking de Jogadores',
  ranking_guild_title: 'Ranking de Clãs',
  ranking_mastery_title: 'Ranking de Maestria',
  ranking_arena_title: 'Ranking Arena PVP',
  ranking_profile_loading: 'Carregando perfil do personagem...',
  ranking_profile_error_title: 'Erro',
  ranking_profile_error_message: 'Não foi possível carregar o perfil do personagem.',
  ranking_profile_back: 'Voltar ao Ranking',
  ranking_profile_inventory: 'Inventário',
  ranking_profile_avatar: 'Avatar',
  ranking_profile_level: 'Nv.',
  ranking_profile_strength: 'For:',
  ranking_profile_intelligence: 'Int:',
  ranking_profile_guild: 'Clã:',
  ranking_profile_no_guild: '<nenhum>',
  job_level: 'Nível',
  job_daily_progress: 'Progresso diário de trabalho',
  job_claimed: 'Reivindicado',
  job_completed: 'Concluído',
  job_in_progress: 'Em Progresso',
  job_gold: 'Ouro',
  job_min: 'min',
  job_delivery_history: 'Histórico de Entregas de Hoje',
  job_route: 'Rota',
  job_gold_earned: 'Ouro Ganho',
  job_delivery_time: 'Tempo de Entrega',
  job_delivery_hour: 'Hora de Entrega',
  job_no_deliveries_today: 'Nenhuma entrega registrada hoje.',
  job_no_job_info: 'Nenhuma informação de trabalho disponível para seu personagem.',
  job_login_required: 'Você deve fazer login para ver seu progresso de trabalho.',
  job_hwid_error: 'Não foi possível recuperar informações de hardware.',
  job_level_error: 'Não foi possível recuperar o nível de trabalho.',
  job_no_configuration: 'Nenhuma configuração disponível para este tipo de trabalho.',
  job_merchant: 'Comerciante',
  job_thief: 'Ladrão',
  job_hunter: 'Caçador',
  job_unknown: 'Desconhecido',
  job_invalid_data: 'Dados inválidos',
  job_already_claimed_today: 'Você já reivindicou a recompensa de hoje.',
  job_complete_progress_first: 'Você deve completar o progresso diário antes de reivindicar a recompensa.',
  job_no_reward_for_level: 'Nenhuma recompensa disponível para seu nível atual.',
  job_reward_claimed_success: 'Recompensa reivindicada com sucesso.',
  job_success: 'Sucesso',
  job_error: 'Erro',
  job_network_error: 'Erro de rede',
  job_protected_cargo: 'Mercadoria Protegida',
  job_stolen_cargo: 'Mercadoria Roubada',
  cupon_title: 'Cupons',
  cupon_level_required: 'Nível',
  cupon_rewards_title: 'Recompensas do Cupom',
  cupon_expires_in: 'Expira em',
  cupon_claim_button: 'Resgatar Cupom',
  cupon_claimed_button: 'Resgatado',
  cupon_confirm_button: 'Confirmar',
  cupon_resend_button: 'Reenviar código',
  cupon_verification_title: 'Inserir código de verificação',
  cupon_choose_channel: 'Where should we send your code?',
  cupon_contact_missing: 'Not configured',
  cupon_whatsapp_verify: 'Verified number required',
  cupon_configure_contact: 'Configure WhatsApp in Settings',
  cupon_sent_via: 'Code sent via {channel}',
  cupon_code_sent_info: 'Um código de verificação será enviado para seu e-mail',
  cupon_code_sent_button: 'Enviado - Verifique seu e-mail',
  cupon_coupon_claimed: 'Cupom resgatado com sucesso! Verifique seu baú no jogo.',
  cupon_no_coupons: 'Nenhum cupom disponível no momento',
  cupon_already_claimed: 'Você já resgatou este cupom',
  cupon_request_error: 'Erro ao solicitar código. Tente novamente.',
  cupon_complete_code: 'Você deve inserir o código completo de 6 dígitos',
  cupon_processing_error: 'Erro ao processar solicitação. Tente novamente.',
  cupon_sending: 'Enviando...',
  cupon_processing: 'Processando...',
  settings_tab_general: 'Geral',
  settings_tab_notifications: 'Notificações',
  settings_tab_restrictions: 'Restrições',
  settings_label_language: 'Idioma',
  settings_label_timezone: 'Fuso Horário',
  settings_label_country: 'País',
  settings_label_whatsapp: 'WhatsApp',
  settings_btn_verify: 'Verificar',
  settings_btn_confirm: 'Confirmar',
  settings_btn_save: 'Salvar',
  settings_btn_validate_now: 'Validar Agora',
  settings_btn_validate_whatsapp: 'Validar por WhatsApp',
  settings_btn_validate_authenticator: 'Validar por Authenticator',
  settings_placeholder_code: 'Código',
  settings_placeholder_phone: '1234567890',
  settings_no_events: 'Nenhum evento configurado',
  settings_minutes_before: 'min antes',
  settings_time_remaining: 'Tempo restante até a próxima validação necessária',
  settings_validation_warning: 'Sua validação expirará em breve. Renove agora para continuar jogando sem interrupções.',
  settings_validation_active: 'Sua conexão está validada e ativa.',
  settings_validation_expired: 'Você deve validar sua conexão para poder se mover no jogo.',
  settings_coming_soon: '(Em Breve)',
  settings_no_hwid: 'Não foi possível obter o HWID. Por favor, faça login no jogo.',
  settings_code_sent: 'Código enviado. Verifique seu WhatsApp.',
  settings_whatsapp_verified_success: 'WhatsApp verificado com sucesso',
  settings_error_update_config: 'Erro ao atualizar configuração',
  settings_error_phone_required: 'Por favor, insira um número de telefone',
  settings_error_code_required: 'Por favor, insira um código válido de 6 dígitos',
  settings_error_send_code: 'Erro ao enviar código de verificação',
  settings_error_verify_code: 'Erro ao verificar código',
  settings_error_validate_connection: 'Erro ao validar conexão',
  settings_error_code_incorrect: 'Código incorreto',
  settings_no_results: 'Nenhum resultado encontrado',
  settings_searching: 'Pesquisando...',
  messages_page_title: 'Chat',
  messages_conversations: 'Conversas',
  messages_new_chat: 'Novo Chat',
  messages_search_player: 'Buscar jogador...',
  messages_type_message: 'Digite uma mensagem...',
  messages_send: 'Enviar',
  messages_attach_item: 'Anexar Item',
  messages_online: 'Online',
  messages_offline: 'Offline',
  messages_no_messages: 'Nenhuma mensagem ainda',
  messages_no_conversations: 'Nenhuma conversa',
  messages_loading: 'Carregando...',
  messages_error_send: 'Erro ao enviar mensagem',
  messages_error_load: 'Erro ao carregar mensagens',
  messages_retry: 'Tentar novamente',
  messages_select_player: 'Selecione um jogador para começar a conversar',
  messages_select_item: 'Selecionar um item',
  messages_item_attached: 'Item anexado',
  messages_remove_item: 'Remover item',
  messages_confirm: 'Confirmar',
  messages_cancel: 'Cancelar',
  messages_today: 'Hoje',
  messages_yesterday: 'Ontem',
  messages_typing: 'digitando...',
  messages_translate: 'Traduzir',
  messages_show_original: 'Mostrar original',
  messages_translate_error: 'Não foi possível traduzir a mensagem',
  messages_scroll_for_more: 'Role para cima para ver mensagens mais antigas',

  notifications_title: 'Notificações',
  notifications_no_notifications: 'Nenhuma notificação disponível',
  notifications_no_type: 'Sem tipo',
  notifications_published: 'Publicado:',
  notifications_expires: 'Expira:',
  notifications_like: 'Curtir',
  notifications_dislike: 'Descurtir',
  notifications_back_to_notifications: 'Voltar para Notificações',
  notifications_vote_error: 'Erro ao atualizar voto',
  notifications_loading: 'Carregando...',
  notifications_error_load: 'Erro ao carregar notificações',
  notifications_not_found: 'Notificação não encontrada ou não disponível',

  dt_title: 'Tarefas Diárias',
  dt_global_progress: 'Progresso Global',
  dt_tasks_completed: 'tarefas concluídas',
  dt_no_tasks: 'Não há tarefas disponíveis no momento.',
  dt_claimed: 'Reivindicada',
  dt_incomplete: 'Incompleta',
  dt_final_rewards: 'Recompensas Finais',
  dt_final_rewards_description:
    'Complete todas as tarefas diárias e reivindique todas as suas recompensas para desbloquear essas recompensas finais.',
  dt_claim_final_reward: 'Reivindicar Recompensa Final',
  dt_complete_all_first: 'Você deve completar e reivindicar todas as tarefas diárias primeiro',
  dt_success: 'Sucesso',
  dt_error: 'Erro',
  dt_network_error: 'Erro de rede',
  dt_processing: 'Processando...',
  dt_login_required: 'Você deve estar logado para ver as tarefas diárias.',
  dt_load_error: 'Não foi possível carregar as tarefas diárias.',

  don_package: 'Pacote:',
  don_silks: 'Silks:',
  don_price: 'Preço:',
  don_silks_label: 'silks',
  don_vip_points: '{amount} Pontos VIP',
  don_promo: 'Promo',
  don_special_offer: 'Oferta Especial',
  don_back: '← Voltar',
  don_pay: 'Pagar $',
  don_continue_paypal: 'Continuar no PayPal',
  don_processing: 'Processando...',
  don_binance_soon: 'Pagamento Binance em breve...',
  don_error_create: 'Erro ao criar pagamento',
  don_stripe_not_loaded: 'Stripe SDK não carregado',
  don_success_processing: 'Processando pagamento...',
  don_success_wait: 'Aguarde enquanto confirmamos sua doação.',
  don_success_ok: 'Pagamento realizado!',
  don_success_fail: 'Pagamento não concluído',
  don_success_fail_msg: 'Não foi possível confirmar sua doação. Tente novamente.',
  don_cancel_title: 'Pagamento cancelado',
  don_cancel_msg: 'Sua doação não foi concluída. Você pode tentar novamente a qualquer momento.',
  don_back_to: 'Voltar às Doações',
  don_credited: '{amount} silks foram creditados na sua conta.',
  cal_claimed: 'Resgatado',
  cal_locked: 'Bloqueado',
  cal_today: 'Hoje',
  cal_claim: 'Resgatar',
  cal_streak_label: 'Dias registrados',
  cal_consecutive_login: 'Login consecutivo',
  cal_upcoming: 'Próximas',
  cal_upcoming_rewards: 'Próximas recompensas',
  cal_no_upcoming: 'Sem próximas',
  cal_monthly_bonus: 'Bônus mensal',
  cal_monthly_bonus_desc: 'Faça check-in por {days} dias para resgatar o bônus mensal.',
  cal_days_remaining: '{days} dias restantes',
  cal_day_remaining: '1 dia restante',
  cal_info_title: 'Informações do evento',
  cal_default_desc: 'Entre todos os dias para resgatar recompensas exclusivas. Perdeu um dia? Continue, o Império espera você.',
  cal_prev: 'Anterior',
  cal_next: 'Próximo',
  cal_bonus_days_unit: 'dias',
  cal_bonus_n_day: '1 dia',
  cal_bonus_n_days: '{days} dias',
  cal_bonus_7_days: '7 dias',
  cal_bonus_15_days: '15 dias',
  cal_bonus_1_month: '1 mês',
  bp_multiple_items: 'Vários itens disponíveis',
  vip_title: 'Sistema VIP',
  vip_col_level: 'NÍVEL',
  vip_col_progress: 'PROGRESSO',
  vip_col_rewards: 'RECOMPENSAS',
  vip_col_state: 'ESTADO',
  vip_level_label: 'Nível VIP ({level})',
  vip_state_unlocked: 'Unlocked',
  vip_no_levels: 'No VIP levels configured.',
  vip_points_rate: '{points} VIP Points.',
  vip_your_points: 'Your points',
  vip_current_level: 'Current level',
  vip_next_level: 'Next level',
  vip_all_unlocked: 'All levels unlocked',
  vip_points_remaining: '{points} points to go',
  vip_information: 'VIP information',
  vip_close: 'Close',
  vip_info_account: 'VIP points belong to your account. Only completed donations with credited VIP points count.',
  vip_info_unlock: 'Reach the required points to unlock each level. Your points accumulate and are not spent when a level unlocks.',
  vip_info_rewards: 'Unlocked means you meet the requirement. Reward claiming and delivery are not available yet.',
  vip_state_locked: 'Bloqueado',
  vip_note: 'Para cada $1 doado, você receberá',
  vip_note_points: '10 Pontos VIP.',
  don_history: "Histórico de compras",
  don_history_loading: "Carregando compras...",
  don_history_error: "Não foi possível carregar o histórico.",
  don_history_empty: "Nenhuma compra ainda.",
  don_history_date: "Data",
  don_history_method: "Método",
  don_history_status: "Status",
  don_history_previous: "Anterior",
  don_history_next: "Próxima",
  don_status_completed: "Concluído",
  don_status_pending: "Pendente",
  don_status_cancelled: "Cancelado",
  don_status_failed: "Falhou",
  don_daily_limit: "Você gastou {current} nas últimas 24 horas. Esta compra de {amount} elevaria o total para {total}, ultrapassando o limite de {limit}. Você tem {remaining} disponíveis.",
  don_limit_available: "Disponível: {amount}",
  don_reset_ready: "Pagamentos nas últimas 24 h",
  don_reset_updating: "Atualizando limite...",
  don_reset_error: "Limite indisponível",
  don_reset_in: "Renova em {time}",
  don_limit_locked: "Você atingiu o limite de pagamentos. Aguarde o fim da contagem regressiva no cabeçalho para pagar novamente.",
} as const;

export default pt;
